import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type TenantEmailDomainFragment = { __typename?: 'TenantEmailDomainData', domain: string, status: Types.EmailSenderVerificationStatus, sendGridDomainId: string, origin: Types.EmailDomainOrigin, boundAt: Types.TDateISO, updatedAt: Types.TDateISO, challengeTxtHost?: string | null, challengeTxtRecord?: string | null, dnsRecords?: Array<{ __typename?: 'TenantEmailDomainDnsRecord', host: string, type: string, data: string, valid: boolean }> | null };

export type GetTenantEmailDomainQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantEmailDomainQuery = { __typename?: 'Query', tenantEmailDomain?: { __typename?: 'TenantEmailDomainData', domain: string, status: Types.EmailSenderVerificationStatus, sendGridDomainId: string, origin: Types.EmailDomainOrigin, boundAt: Types.TDateISO, updatedAt: Types.TDateISO, challengeTxtHost?: string | null, challengeTxtRecord?: string | null, dnsRecords?: Array<{ __typename?: 'TenantEmailDomainDnsRecord', host: string, type: string, data: string, valid: boolean }> | null } | null };

export const TenantEmailDomainFragmentDoc = new TypedDocumentString(`
    fragment TenantEmailDomain on TenantEmailDomainData {
  domain
  status
  sendGridDomainId
  origin
  boundAt
  updatedAt
  challengeTxtHost
  challengeTxtRecord
  dnsRecords {
    host
    type
    data
    valid
  }
}
    `, {"fragmentName":"TenantEmailDomain"});
export const GetTenantEmailDomainDocument = new TypedDocumentString(`
    query GetTenantEmailDomain {
  tenantEmailDomain {
    ...TenantEmailDomain
  }
}
    fragment TenantEmailDomain on TenantEmailDomainData {
  domain
  status
  sendGridDomainId
  origin
  boundAt
  updatedAt
  challengeTxtHost
  challengeTxtRecord
  dnsRecords {
    host
    type
    data
    valid
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTenantEmailDomain: build.query<GetTenantEmailDomainQuery, GetTenantEmailDomainQueryVariables | void>({
      query: (variables) => ({ document: GetTenantEmailDomainDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTenantEmailDomainQuery, useLazyGetTenantEmailDomainQuery } = injectedRtkApi;
